import { render, staticRenderFns } from "./suspicionCase.vue?vue&type=template&id=8d8e94c8"
import script from "./suspicionCase.vue?vue&type=script&lang=js"
export * from "./suspicionCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports